document.addEventListener("DOMContentLoaded", function () {
  // Custom scrollbar initialization
  scrollWidthInitializer();

  function scrollWidthInitializer() {
      // Implement your custom scrollbar initialization logic here
      console.log("Custom scrollbar initialized");
  }

  function scrollSlider(elem, scrollBy, scrollRight) {
      const firstItem = elem.querySelector('.grid-product, .slider-box');
      if (!firstItem) {
          console.error('No .grid-product or .slider-box found in the slider');
          return;
      }
      const width = firstItem.offsetWidth * scrollBy;
      
      if (scrollRight) {
          if (elem.scrollWidth - elem.scrollLeft !== elem.offsetWidth) {
              elem.scrollTo({
                  left: elem.scrollLeft + width,
                  behavior: 'smooth'
              });
          }
      } else {
          if (elem.scrollLeft > 0) {
              elem.scrollTo({
                  left: elem.scrollLeft - width,
                  behavior: 'smooth'
              });
          }
      }
  }

  document.querySelectorAll('.horizon-next, .horizon-prev').forEach(button => {
      button.addEventListener('click', function(event) {
          event.preventDefault();
          if (window.scrollingSlider) return;

          const sliderWrapper = this.closest('.slider-wrapper');
          if (!sliderWrapper) {
              console.error('Could not find .slider-wrapper ancestor');
              return;
          }

          const elem = sliderWrapper.querySelector('.custom-slider');
          if (!elem) {
              console.error('Could not find .custom-slider within .slider-wrapper');
              return;
          }

          const mediaQuery = window.matchMedia('(max-width: 768px)');
          if (mediaQuery.matches) {
              const scrollBtnWrapper = this.parentNode;
              if (!scrollBtnWrapper) {
                  console.error('Could not find parent node of the button');
                  return;
              }

              if (this.classList.contains('horizon-next')) {
                  const scrollIndex = scrollBtnWrapper.dataset.scrollItem;
                  const scrollElement = elem.querySelector(`div[data-scroll-id="${scrollIndex}"]`);
                  if (!scrollElement) {
                      console.warn(`No element found with data-scroll-id="${scrollIndex}"`);
                      return;
                  }
                  elem.scrollTo({
                      left: scrollElement.offsetLeft,
                      behavior: 'smooth'
                  });
                  scrollBtnWrapper.dataset.scrollItem = parseInt(scrollIndex) + 1;
              } else if (this.classList.contains('horizon-prev')) {
                  const scrollLength = 2;
                  const lastElement = elem.querySelector('div[data-scroll-id]:last-child');
                  const lastElementId = lastElement ? parseInt(lastElement.dataset.scrollId) : 0;
                  if (parseInt(scrollBtnWrapper.dataset.scrollItem) === lastElementId) {
                      scrollSlider(elem, 1, false);
                      return;
                  }
                  const scrollIndex = Math.max(parseInt(scrollBtnWrapper.dataset.scrollItem) - scrollLength, 0);
                  const scrollElement = elem.querySelector(`div[data-scroll-id="${scrollIndex}"]`);
                  if (!scrollElement) {
                      console.warn(`No element found with data-scroll-id="${scrollIndex}"`);
                      return;
                  }
                  elem.scrollTo({
                      left: scrollElement.offsetLeft,
                      behavior: 'smooth'
                  });
                  scrollBtnWrapper.dataset.scrollItem = scrollIndex;
              }
          } else {
              if (this.classList.contains('horizon-next')) {
                  scrollSlider(elem, 3, true);
              } else if (this.classList.contains('horizon-prev')) {
                  scrollSlider(elem, 3, false);
              }
          }
      });
  });

  document.querySelectorAll('.custom-slider').forEach(slider => {
      slider.addEventListener('scroll', function() {
          window.scrollingSlider = true;
          const galleryAvailScroll = this.scrollWidth - this.offsetWidth;
          const scrollbarElement = this.nextElementSibling?.querySelector('.scrollbar');
          const scrollbarHandleElement = this.nextElementSibling?.querySelector('.scrollbar-handle');
          
          if (scrollbarElement && scrollbarHandleElement) {
              const handlerAvailScroll = scrollbarElement.offsetWidth - scrollbarHandleElement.offsetWidth;
              const handlerLeft = this.scrollLeft * handlerAvailScroll / galleryAvailScroll;
              scrollbarHandleElement.style.left = `${handlerLeft}px`;
          }

          const scrollBtnWrapper = this.nextElementSibling?.querySelector('div[data-scroll-item]');
          if (scrollBtnWrapper) {
              if (window.innerWidth <= 768) {
                  clearTimeout(this.scrollTimer);
                  this.scrollTimer = setTimeout(() => {
                      const itemsInViewport = Array.from(this.querySelectorAll('div[data-scroll-id]'))
                          .filter(el => {
                              const rect = el.getBoundingClientRect();
                              return rect.left >= 0 && rect.right <= window.innerWidth;
                          });
                      const lastVisibleElement = itemsInViewport[itemsInViewport.length - 1];
                      if (lastVisibleElement) {
                          const scrollItem = parseInt(lastVisibleElement.dataset.scrollId);
                          scrollBtnWrapper.dataset.scrollItem = scrollItem;
                      }
                      window.scrollingSlider = false;
                  }, 250);
              } else {
                  window.scrollingSlider = false;
              }
          }
      });
  });
});